import PaymentsTransactionResource from './transaction';

export default function PaymentsResource({ base }) {
  const paymentsBase = `${base}/payments`;

  return {
    Transaction: PaymentsTransactionResource({ base: paymentsBase }),
  };
}
